var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavigator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.502 20.9043L12.4138 0.910366C12.1618 0.355953 11.609 0 11 0C10.391 0 9.8382 0.355954 9.5862 0.910368L0.498047 20.9043C0.198468 21.5634 0.339142 22.3391 0.851063 22.8511C1.4976 23.4976 2.5347 23.5321 3.22282 22.93L9.24742 17.6585C9.73258 17.234 10.3553 17 11 17C11.6447 17 12.2674 17.234 12.7526 17.6585L18.7772 22.93C19.4653 23.5321 20.5024 23.4976 21.1489 22.8511C21.6609 22.3391 21.8015 21.5634 21.502 20.9043Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigator);
export default __webpack_public_path__ + "static/media/Navigator.47b034fbd8dc8db0f8c1cd6b101ec39b.svg";
export { ForwardRef as ReactComponent };